import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { SasTokenResponse } from '@app/utils/interfaces/sas-token-response.interface';
import { environment } from '@env/environment';
import { map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SasTokenService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public getSasToken(fileUrl: string): Observable<string> {
    return this.httpClient
      .get<SasTokenResponse>(this.baseUrl + ApiEndpoints.GET_SAS_TOKEN, {
        params: { fileUrl },
      })
      .pipe(
        take(1),
        map((payload: SasTokenResponse) => {
          return payload.data.sasToken;
        }),
      );
  }

  public static isSasTokenExpired(sasToken: string): boolean {
    const params = new URLSearchParams(sasToken);

    const expirationPart: string | null = params.get('se');

    if (!expirationPart) {
      return true;
    }

    const expirationDate = new Date(decodeURIComponent(expirationPart));
    const now = new Date();

    return now > expirationDate;
  }
}
